import React from "react";
import useSeo from "@/hooks/useSeo";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeader from "@/components/PageHeader";
import Contact from "@/components/Contact";

const ContactPage = () => {
  useSeo({
    title: "Contact | Plan een Strategiegesprek",
    description:
      "Neem contact op met UPPIT. WhatsApp Tim direct op +31 6 41262267, mail info@uppit.nl of vul het contactformulier in. Reactie binnen 24 uur.",
    path: "/contact",
    ogSlug: "page/contact",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contact UPPIT",
      url: "https://uppit.nl/contact",
    },
  });

  return (
    <main data-testid="contact-page" className="bg-ivory">
      <section className="pt-32 max-w-[1400px] mx-auto px-6 lg:px-12">
        <Breadcrumb
          items={[
            { label: "Home", href: "/" },
            { label: "Contact", href: "/contact" },
          ]}
        />
        <PageHeader
          kicker="Contact · Schrijf ons"
          italic="Een goed gesprek."
          bold="Meestal genoeg."
          lede="Bel, WhatsApp of mail direct. Binnen 30 minuten weet je waar de groeikansen zitten — geen offerte-carrousel, geen sales-script."
        />
      </section>
      <Contact />
    </main>
  );
};

export default ContactPage;
